import ApiService from "../../../../services/ApiService";
import Logger from "../../../../services/Logger";

const FeedbackService = {
    /**
     * Submit feedback for a puzzle
     * @param {Object} feedbackData - Feedback data object
     * @param {string} feedbackData.gridId - Grid puzzle ID (optional)
     * @param {string} feedbackData.crossId - Crossword puzzle ID (optional)
     * @param {string} feedbackData.cloudUserId - User ID (optional)
     * @param {number} feedbackData.stars - Star rating 1-5 (optional)
     * @param {number} feedbackData.difficultyDelta - Difficulty delta: -1 (easier), 0 (expected), 1 (harder) (optional)
     * @param {string} feedbackData.comment - Comment text (optional)
     * @returns {Promise<Object>} API response
     */
    submitFeedback: async (feedbackData) => {
        try {
            Logger.log("FeedbackService - Received feedback data:", feedbackData);
            
            const body = {
                gridId: feedbackData.gridId || null,
                crossId: feedbackData.crossId || null,
                cloudUserId: feedbackData.cloudUserId || null,
                stars: feedbackData.stars !== undefined && feedbackData.stars !== null ? feedbackData.stars : null,
                // Handle difficultyDelta: 0 is a valid value (Expected), so check for null/undefined specifically
                difficultyDelta: feedbackData.difficultyDelta !== undefined && feedbackData.difficultyDelta !== null ? feedbackData.difficultyDelta : null,
                comment: feedbackData.comment || null,
                details: feedbackData.details && typeof feedbackData.details === "object"
                    ? feedbackData.details
                    : null,
            };

            Logger.log("FeedbackService - Sending to API:", body);

            const result = await ApiService.postDataOptionalAuth("/home/feedback", body);

            if (result && result.code === "FAILURE") {
                throw new Error(result.message || "Failed to submit feedback");
            }

            return result;
        } catch (error) {
            Logger.error("Error submitting feedback:", error);
            throw error;
        }
    }
};

export default FeedbackService;

